const config = { attributes: false, childList: true, subtree: true };

// Callback function to execute when mutations are observed
const callback = (mutationList, observer) => {
  for (const mutation of mutationList) {
    if (mutation.type === "childList") {
      const loginLock = document.querySelectorAll('.bss-lock-element > a');
      loginLock.forEach(message => {
        if (message.href !== '/pages/registrierung') {
          message.href ='/pages/registrierung'
        }
      });
    }
  }
};

// Create an observer instance linked to the callback function
const observer = new MutationObserver(callback);

// Start observing the target node for configured mutations
observer.observe(document.body, config);